export function normalizujAdminEmail(
  email
) {
  return String(
    email || ""
  )
    .trim()
    .toLowerCase();
}

export function ziskajAdminEmailDomenu(
  email
) {
  const hodnota =
    normalizujAdminEmail(
      email
    );

  const index =
    hodnota.lastIndexOf("@");

  if (
    index <= 0 ||
    index ===
      hodnota.length - 1
  ) {
    return "";
  }

  return hodnota.slice(
    index + 1
  );
}

export function jeOdporucanaAdminEmailDomena(
  email,
  odporucaneDomeny = []
) {
  const domeny =
    Array.isArray(
      odporucaneDomeny
    )
      ? odporucaneDomeny
          .map(
            (domena) =>
              String(
                domena || ""
              )
                .trim()
                .toLowerCase()
                .replace(
                  /^@+/,
                  ""
                )
          )
          .filter(Boolean)
      : [];

  if (!domeny.length) {
    return true;
  }

  return domeny.includes(
    ziskajAdminEmailDomenu(
      email
    )
  );
}

export function vytvorTextAdminEmailDomeny(
  odporucaneDomeny = []
) {
  const domeny =
    Array.isArray(
      odporucaneDomeny
    )
      ? odporucaneDomeny
          .map(
            (domena) =>
              String(
                domena || ""
              )
                .trim()
                .toLowerCase()
          )
          .filter(Boolean)
      : [];

  if (!domeny.length) {
    return "";
  }

  if (domeny.length === 1) {
  return `Mail by mal byť @${domeny[0]}`;
}

if (domeny.length === 2) {
  return `Mail by mal byť @${domeny[0]} alebo @${domeny[1]}`;
}

return `Mail by mal byť ${domeny
  .map(
    (domena) =>
      `@${domena}`
  )
  .join(", ")}`;
}